export default "__VITE_ASSET__J7lAgKJ___"